import { createFileRoute } from '@tanstack/react-router';
import { Lock } from 'lucide-react';

import { ServiceCatalogPage } from '@/features/service-catalog/components/service-catalog-page';
import { useCurrentUserRole } from '@/lib/team';

export const Route = createFileRoute('/_app/crm/catalog/')({
  component: CatalogLayout,
});

function CatalogLayout() {
  const role = useCurrentUserRole();

  if (role !== 'owner') {
    return (
      <div
        className="mx-auto flex max-w-md flex-col items-center justify-center gap-3 rounded-lg border py-16 text-center"
        style={{ borderColor: 'var(--color-border)' }}
      >
        <Lock className="h-6 w-6" style={{ color: 'var(--color-fg-subtle)' }} aria-hidden />
        <h2 className="text-base font-semibold" style={{ color: 'var(--color-fg)' }}>
          Acceso restringido
        </h2>
        <p className="text-sm" style={{ color: 'var(--color-fg-muted)' }}>
          El catálogo de servicios es exclusivo del owner de la organización.
        </p>
      </div>
    );
  }

  return <ServiceCatalogPage />;
}
